import { Injectable } from '@angular/core';
import { User } from 'src/app/models/user';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CurrentUser } from 'src/app/models/current-user';
import { UserPermissionsResponse, UpdateUserPermissionsRequest, UpdateUserPermissionItem } from 'src/app/models/user-permission';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(
      `${environment.apiUrl}/user`
    );
  }

  getUserById(id: string): Observable<User> {
    return this.http.get<User>(
      `${environment.apiUrl}/user/id/${id}`
    );
  }

  searchIdentifierDataForId(id: string): Observable<User> {
    return this.http.get<User>(
      `${environment.apiUrl}/user/identifier/${id}`
    );
  }

  searchIdentifierDataForName(name: string): Observable<User[]> {
    return this.http.get<User[]>(
      `${environment.apiUrl}/user/identifier?name=${encodeURIComponent(name)}`
    );
  }


  create(user: User): Observable<number> {
    return this.http.post<number>(`${environment.apiUrl}/user`, {
      pidm: user.pidm,
      username: user.username
    });
  }

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(
      `${environment.apiUrl}/login/current-user`
    );
  }

  getUserPermissions(userId: string) {
    return this.http.get<UserPermissionsResponse>(`${environment.apiUrl}/user/${userId}/permissions`);
  }

  updateUserPermissions(userId: string, permissions: UpdateUserPermissionItem[]) {
    const requestBody: UpdateUserPermissionsRequest = { permissions };
    return this.http.put<void>(`${environment.apiUrl}/user/${userId}/permissions`, requestBody);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/user/id/${id}`);
  }

  getFacultyAccesses(userId: string): Observable<{ id: number; code: string; name: string }[]> {
    return this.http.get<{ id: number; code: string; name: string }[]>(`${environment.apiUrl}/user/${userId}/faculty-access`);
  }

  updateFacultyAccesses(userId: string, facultyIds: number[]): Observable<{ id: number; code: string; name: string }[]> {
    return this.http.patch<{ id: number; code: string; name: string }[]>(
      `${environment.apiUrl}/user/${userId}/faculty-access`,
      { facultyIds }
    );
  }
}
